export default __webpack_public_path__ + "static/media/bottom-section-bg-mobile.b1ac658c.svg";